export default __webpack_public_path__ + "static/media/circle06.812c49c2.svg";